import { useDispatch } from "react-redux";
import {
  addDialog,
  updateDialog,
  removeDialog,
  clearDialogs as clearDialogsSlice,
} from "./dialogSlice";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { RootState } from "../../state";
import { useSelector } from "react-redux";
import { DialogSize, DialogData } from "./dialogSlice";

export default function DialogService() {
  const dispatch = useDispatch();
  const dialogData = useSelector((state: RootState) => state.dialog);

  const open = (
    nTitle: string,
    nContent: any,
    nActions: Array<ReactJSXElement>,
    nReload?: boolean
  ) => {
    const newDialog: DialogData = {
      open: true,
      scroll: "paper",
      title: nTitle,
      content: nContent,
      actions: nActions,
      reload: nReload ? nReload : false,
      size: DialogSize.LG,
    };

    dispatch(addDialog(newDialog));
  };

  const openSM = (
    nTitle: string,
    nContent: any,
    nActions: Array<ReactJSXElement>,
    nReload?: boolean
  ) => {
    const newDialog: DialogData = {
      open: true,
      scroll: "paper",
      title: nTitle,
      content: nContent,
      actions: nActions,
      reload: nReload ? nReload : false,
      size: DialogSize.SM,
    };

    dispatch(addDialog(newDialog));
  };

  const openMD = (
    nTitle: string | ReactJSXElement,
    nContent: any,
    nActions: Array<ReactJSXElement>,
    nReload?: boolean
  ) => {
    const newDialog: DialogData = {
      open: true,
      scroll: "paper",
      title: nTitle,
      content: nContent,
      actions: nActions,
      reload: nReload ? nReload : false,
      size: DialogSize.MD,
    };

    dispatch(addDialog(newDialog));
  };

  const openXS = (
    nTitle: string,
    nContent: any,
    nActions: Array<ReactJSXElement>,
    nReload?: boolean
  ) => {
    const newDialog: DialogData = {
      open: true,
      scroll: "paper",
      title: nTitle,
      content: nContent,
      actions: nActions,
      reload: nReload ? nReload : false,
      size: DialogSize.XS,
    };

    dispatch(addDialog(newDialog));
  };

  const close = () => {
    if (dialogData.dialogs.length > 0) {
      const lastDialog = dialogData.dialogs[dialogData.dialogs.length - 1];

      const newDialog: DialogData = {
        open: false,
        scroll: lastDialog.scroll,
        title: lastDialog.title,
        content: lastDialog.content,
        actions: lastDialog.actions,
        reload: lastDialog.reload,
        size: lastDialog.size,
      };

      dispatch(
        updateDialog({
          index: dialogData.dialogs.length - 1,
          dialog: newDialog,
        })
      );
      if (newDialog.reload === false) {
        dispatch(removeDialog(dialogData.dialogs.length - 1));
      }
    }
  };

  const closeAll = () => {
    const qty = dialogData.dialogs.length;
    for (let i = 0; i < qty; i++) {
      close();
    }
  };

  const closeReload = () => {
    if (dialogData.dialogs.length > 0) {
      const lastDialog = dialogData.dialogs[dialogData.dialogs.length - 1];

      const newDialog: DialogData = {
        open: false,
        scroll: lastDialog.scroll,
        title: lastDialog.title,
        content: lastDialog.content,
        actions: lastDialog.actions,
        reload: true,
        size: lastDialog.size,
      };

      dispatch(
        updateDialog({
          index: dialogData.dialogs.length - 1,
          dialog: newDialog,
        })
      );
    }
  };

  const removeLastDialog = () => {
    if (dialogData.dialogs.length > 0) {
      dispatch(removeDialog(dialogData.dialogs.length - 1));
    }
  };

  const clearDialogs = () => {
    if (dialogData.dialogs.length > 0) {
      dispatch(clearDialogsSlice());
    }
  };

  return {
    openXS,
    openSM,
    openMD,
    closeAll,
    open,
    close,
    closeReload,
    removeLastDialog,
    clearDialogs,
  };
}
